module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block-content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "base_forms_premade.html",
      "method": "post",
      "onsubmit": "return false;"
    }
  }, [_c('h3', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.sectionLabelCreateSignalsSet[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.textBoxLabelTemplateId[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.templateId),
      expression: "templateId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Identifant de gabarit / Template ID"
    },
    domProps: {
      "value": (_vm.templateId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.templateId = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleVariables[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, _vm._l((_vm.deviceSignals), function(signal, index) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.signalName),
        expression: "signal.signalName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (signal.signalName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(signal, "signalName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.signalLabel.FR),
        expression: "signal.signalLabel.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (signal.signalLabel.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(signal.signalLabel, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.signalLabel.EN),
        expression: "signal.signalLabel.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (signal.signalLabel.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(signal.signalLabel, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableDataFormat[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.dataFormat),
        expression: "signal.dataFormat"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(signal, "dataFormat", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Single"
      }
    }, [_vm._v("Simple / Single")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Array"
      }
    }, [_vm._v("Vecteur (liste) / Array")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-6"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelVariableDataType[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (signal.dataType),
        expression: "signal.dataType"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(signal, "dataType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "Numeric"
      }
    }, [_vm._v("Numerique / Numeric")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Bool"
      }
    }, [_vm._v("Booléen / Boolean")])])])])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addDeviceSignal()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddSignal[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.deviceSignals.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDeviceSignal()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteSignal[_vm.actualLanguage]))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "block block-bordered block-themed"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('h4', {
    staticClass: "font-w300 push-10 text-white-op"
  }, [_vm._v(_vm._s(_vm.textSectionTitleControlParameter[_vm.actualLanguage]))])])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription01[_vm.actualLanguage]))]), _vm._v(" "), _c('h5', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.textParameterDescription02[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.controlParameters), function(parameter, index3) {
    return _c('div', {
      staticClass: "col-xs-12 col-md-12"
    }, [_c('div', {
      staticClass: "block block-bordered block-themed block-content"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelFR[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.parameterLabel.FR),
        expression: "parameter.parameterLabel.FR"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (parameter.parameterLabel.FR)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter.parameterLabel, "FR", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterLabelEN[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.parameterLabel.EN),
        expression: "parameter.parameterLabel.EN"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Nom/Name"
      },
      domProps: {
        "value": (parameter.parameterLabel.EN)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter.parameterLabel, "EN", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-4"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterVarName[_vm.actualLanguage]))]), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.parameterName),
        expression: "parameter.parameterName"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Variable"
      },
      domProps: {
        "value": (parameter.parameterName)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "parameterName", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-12 col-md-6 col-lg-3"
    }, [_c('label', {
      attrs: {
        "for": "example-multiple-select"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterDataType[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.dataType),
        expression: "parameter.dataType"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "dataType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.changeDataType(index3)
        }]
      }
    }, [_c('option', {
      attrs: {
        "value": "Numeric"
      }
    }, [_vm._v("Numerique / Numeric")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "String"
      }
    }, [_vm._v("Chaîne caractère / String")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "Bool"
      }
    }, [_vm._v("Booléen / Boolean")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagVisibleByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagViewByCustomer),
        expression: "parameter.flagViewByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagViewByCustomer) ? _vm._i(parameter.flagViewByCustomer, null) > -1 : (parameter.flagViewByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagViewByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagViewByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagViewByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagViewByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-md-3"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('label', {
      attrs: {
        "for": "register4-firstname"
      }
    }, [_vm._v(_vm._s(_vm.labelParameterFlagEditByCustomer[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.flagEditByCustomer),
        expression: "parameter.flagEditByCustomer"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.flagEditByCustomer) ? _vm._i(parameter.flagEditByCustomer, null) > -1 : (parameter.flagEditByCustomer)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.flagEditByCustomer,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "flagEditByCustomer", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "flagEditByCustomer", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "flagEditByCustomer", $$c)
          }
        }
      }
    }), _c('span')])])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addDeviceControlParameter()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonAddParameter[_vm.actualLanguage]))])])])]), _vm._v(" "), (_vm.controlParameters.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('p', [_c('button', {
    staticClass: "btn btn-sm btn-danger",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteDeviceControlParameter()
      }
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-minus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonDeleteParameter[_vm.actualLanguage]))])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.deviceSignals.length > 0) ? _c('div', {
    staticClass: "col-sm-12 col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-12 col-lg-12 push"
  }, [_c('label', {
    attrs: {
      "for": "register4-firstname"
    }
  }, [_vm._v(_vm._s(_vm.labelSelectApiKey[_vm.actualLanguage]) + " ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedApiKey),
      expression: "selectedApiKey"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedApiKey = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.overlayParameters.organizationApiKeys), function(key) {
    return _c('option', {
      domProps: {
        "value": key.key
      }
    }, [_vm._v(_vm._s(key.referenceName) + " : " + _vm._s(key.key))])
  }), 0)]), _vm._v(" "), (_vm.selectedApiKey.length > 0) ? _c('div', [_c('p', [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveSignalSetTemplate()
      }
    }
  }, [(_vm.templateIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSave[_vm.actualLanguage]))])], 1)])]) : _vm._e()]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4753cc00","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/OrganizationApiSignalsSetAddForm.vue
// module id = 1523
// module chunks = 4